import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

// SVG Imports
import ISO2700 from "../../../assets/landingPage/ISO27001.png";
import ISO9001 from "../../../assets/landingPage/ISO9001.png";
import LinkdIn from "../../../assets/landingPage/LinkedIn.svg";
import NavXpentraLogo from "../../../assets/landingPage/NavXpentraLogo.svg";
import NavXpentraLogoMob from "../../../assets/landingPage/NavXpentraLogoMob.svg";

// REDUX Imports
import { toast_position } from "../../../redux/features/Settings/Authorization";
import SVGComponent from "../../_utils/SVGComponent";
import ICONS from "../../../assets/Icons";

const Footer = () => {
  // useNavigate
  const navigate = useNavigate();

  // useLocation
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  const isActive = (route) => location.pathname === route;

  // useLocation


  const isBookDemoPage = location.pathname === "/book_demo";
  const [isHover, setIsHover] = useState(false);

  const showToast = () => {
    toast.info("Feature coming soon!", toast_position);
  };

  return (
    <>
      <div>
        {/* <div
          id="comment-code-1"
          className={`inline-block px-2 py-1 
                    ${
                      isActive("/bank_statement") ||
                      isActive("/view_all_balances")
                        ? "border-b-pending text-pending"
                        : ""
                    }`}
        >
          <span
            className={`${
              isActive("/bank_statement") || isActive("/view_all_balances")
                ? "border-b-pending text-pending"
                : ""
            }`}
            onClick={() => navigate("/bank_statement")}
          >
            Product
          </span>
        </div> */}

        {/* <div
          id="comment-code-2"
          className={`w-[75px]`}
        >
          <span
            className={`hover:text-pending cursor-pointer ${
              isActive("/bank_statement") || isActive("/view_all_balances")
                ? "border-b-pending text-pending border-b border-current"
                : ""
            }`}
            onClick={() => navigate("/bank_statement")}
          >
            Product
          </span>
        </div> */}

        {/* <div
          id="comment-code-3"
          className={`w-[75px]`}
        >
          <span
            className={`hover:text-pending cursor-pointer ${
              isActive("/pricing")
                ? "text-pending border-b-pending border-b border-current"
                : ""
            }`}
            onClick={() => navigate("/pricing")}
          >
            Pricing
          </span>
        </div> */}

        <div className="bg-[#031F4F]">
          <div className="lg:max-w-[1024px] lg:mx-auto lg:pt-[30px] lg:flex lg:flex-col lg:gap-[18px]">
            <div className="flex flex-col justify-center pb-5 lg:pb-padding-base bg-[#031F4F]">
              <div className="mx-auto lg:py-padding-base py-5">
                <img
                  src={ICONS?.XPENTRA_SYMBOL_WHITE}
                  alt="loader-new"
                />
              </div>

              <div className="text-text-primary lg:mb-margin-lg">
                <p className="text-font-xl text-center font-semibold mb-margin-sm">
                  See Xpentra in action
                </p>
                <p className="text-xs text-center">
                  Request a personalised demo to explore how it can <br />{" "}
                  streamline your operations!
                </p>
              </div>
              <div className="mt-[20px] lg:mt-margin-base mx-auto">
                <div
                  onClick={() => {
                    if (!isBookDemoPage) {
                      navigate("/book_demo");
                    }
                  }}
                  onMouseEnter={() => !isBookDemoPage && setIsHover(true)}
                  onMouseLeave={() => !isBookDemoPage && setIsHover(false)}
                  className={`rounded-[5px] w-[215px] text-center text-xs font-semibold py-[10px] flex gap-2.5 items-center justify-center   ${
                    isBookDemoPage
                      ? "text-[#1D3A6D] bg-text-secondary cursor-not-allowed"
                      : "text-[#1D3A6D] bg-text-primary hover:bg-[#1D3A6D] hover:text-text-primary cursor-pointer"
                  }`}
                >
                  Click here to request a demo
                  <SVGComponent
                    url={ICONS?.ARROW_RIGHT_WHITE}
                    height={"12px"}
                    width={"12px"}
                    color={
                      isBookDemoPage
                        ? "var(--primary-bg)"
                        : isHover
                          ? "var(--text-primary)"
                          : "var(--primary-bg)"
                    }
                  />
                </div>
              </div>
            </div>
            <div className="border-t-[1px] lg:border-t-border-base border-t-text-secondary mx-[30px] lg:mx-margin-base py-[30px] lg:pb-padding-base flex flex-col gap-[30px] lg:gap-4">
              <div className="flex flex-col lg:flex-row justify-between gap-gap-lg lg:gap-gap-base">
                <div className="flex flex-col gap-4 items-center lg:items-start">
                  <div>
                    <picture>
                      <source
                        media="(min-width: 1025px)"
                        srcSet={NavXpentraLogo}
                      />
                      <img
                        className="lg:ml-[-8px]"
                        src={NavXpentraLogoMob}
                        alt="NavXpentraLogo"
                      />
                    </picture>
                  </div>
                  <div
                    onClick={() =>
                      window.open(
                        "https://www.linkedin.com/company/xpentra",
                        "_blank",
                      )
                    }
                    className="cursor-pointer"
                  >
                    <img
                      src={LinkdIn}
                      alt="linkdin"
                    />
                  </div>
                </div>
                <div className="text-xs text-text-primary items-center font-normal text-center flex  flex-col lg:flex-col gap-3 lg:gap-[15px] lg:pt-2">
                  <div className="flex-col lg:flex-row flex justify-start text-center lg:text-start lg:gap-[50px] gap-3 ">
                    <div className="lg:w-[75px]">
                      <span
                        className={`lg:hover:text-pending lg:cursor-pointer inline-block px-2  lg:px-padding-base lg:py-padding-base ${
                          isActive("/")
                            ? "border-b-pending text-pending lg:border-b lg:border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/")}
                      >
                        Home
                      </span>
                    </div>
                    {/* <div
                id="commented code"
                className={`inline-block px-2 py-1 
                    ${
                      isActive("/bank_statement") ||
                      isActive("/view_all_balances")
                        ? "border-b-pending text-pending"
                        : ""
                    }`}
              >
                <span
                  className={`${
                    isActive("/bank_statement") ||
                    isActive("/view_all_balances")
                      ? "border-b-pending text-pending"
                      : ""
                  }`}
                  onClick={() => navigate("/bank_statement")}
                >
                  Product
                </span>
              </div> */}
                    <div className="lg:w-[75px]">
                      <span
                        className={`lg:hover:text-pending lg:cursor-pointer inline-block px-2 lg:px-padding-base lg:py-padding-base py-1  ${
                          isActive("/product")
                            ? "border-b-pending text-pending lg:border-b lg:border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/product")}
                      >
                        Product
                      </span>
                    </div>
                    <div className="lg:w-[75px]">
                      <span
                        className={`lg:hover:text-pending lg:cursor-pointer inline-block px-2 py-1 lg:px-padding-base lg:py-padding-base  ${
                          isActive("/aboutus") || isActive("/advisors")
                            ? "border-b-pending text-pending lg:border-b lg:border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/aboutus")}
                      >
                        About Us
                      </span>
                    </div>
                  </div>

                  <div className="flex  flex-col lg:flex-row justify-start text-center lg:text-start lg:gap-[50px] gap-3 ">
                    <div className="lg:w-[75px]">
                      <span
                        className={`lg:hover:text-pending lg:cursor-pointer inline-block px-2 py-1 lg:px-padding-base lg:py-padding-base  ${
                          isActive("/pricing")
                            ? " border-b-pending text-pending lg:border-b lg:border-currentborder-b-pending "
                            : ""
                        }`}
                        onClick={() => navigate("/pricing")}
                      >
                        Pricing
                      </span>
                    </div>
                    <div className="lg:w-[75px]">
                      <span
                        className={`lg:hover:text-pending lg:cursor-pointer inline-block px-2 py-1 lg:px-padding-base lg:py-padding-base  ${
                          isActive("/contactus")
                            ? "border-b-pending text-pending lg:border-b lg:border-current"
                            : ""
                        }`}
                        onClick={() => navigate("/contactus")}
                      >
                        Contact Us
                      </span>
                    </div>
                    <div className="lg:w-[75px]">
                      <span
                        className={`lg:hover:text-pending lg:cursor-pointer inline-block px-2 py-1 lg:px-padding-base lg:py-padding-base  ${
                          isActive("/faq")
                            ? "border-b-pending text-pending lg:border-b lg:border-current"
                            : ""
                        }`}
                        onClick={() => {
                          showToast();
                        }}
                      >
                        FAQ
                      </span>{" "}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-between flex-col lg:flex-row gap-gap-lg lg:gap-gap-base ">
                <div className="flex flex-col items-center text-text-primary text-xs">
                  <div className="flex  lg:gap-2 gap-4">
                    <div className="w-[77.78px] py-5">
                      <a
                        href="https://ssl.comodo.com/ev-ssl-certificates.php"
                        // id="comodoTL"
                      >
                        <img
                          src="https://q2pay.in/new_assets/web/sectigo_trust_seal.png"
                          alt="Secured By Entrust, SSL (Secure Sockets Layer). Verify"
                          className=" "
                        />
                      </a>
                    </div>
                    <div className="w-[30px] py-5">
                      <img
                        src={ISO9001}
                        alt="ISO9001"
                      />
                    </div>
                    <div className="w-[30px] py-5">
                      <img
                        src={ISO2700}
                        alt="ISO2700"
                      />
                    </div>
                  </div>
                </div>
                <div className=" lg:flex-row lg:flex-grow  flex flex-col items-center gap-2.5 text-center text-text-primary text-xs lg:justify-center">
                  <div
                    className={`border-b border-current cursor-pointer ${
                      isActive("/terms_conditions")
                        ? "text-pending border-b-pending"
                        : "hover:text-pending hover:border-pending"
                    }`}
                    onClick={() => navigate("/terms_conditions")}
                  >
                    Terms and Conditions
                  </div>
                  <div
                    className={`border-b border-current cursor-pointer ${
                      isActive("/privacy_policy")
                        ? "text-pending border-b-pending"
                        : "hover:text-pending hover:border-pending"
                    }`}
                    onClick={() => navigate("/privacy_policy")}
                  >
                    Privacy Policy
                  </div>
                  <span>
                    © Copyright {currentYear} Q2Pay Technologies Pvt Ltd. All
                    rights reserved
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
